/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View } from 'react-native';
import { billingStyles as styles } from '../billingScreen.styles';

type Props = {
  lines: string[];
};

/** Lista corta tipo proto: viñetas, sin iconos ni grupos. */
export function BillingPlanHighlights({ lines }: Props) {
  if (lines.length === 0) return null;
  return (
    <View style={styles.planHighlights}>
      {lines.map((line) => (
        <Text key={line} style={styles.planHighlightLine}>
          • {line}
        </Text>
      ))}
    </View>
  );
}
